import React from "react"

import { Button } from "@/components/ui/Button"

import checkIcon from "../../../assets/images/order/check.png"

interface PricingCardProps {
  title: string
  price?: React.ReactNode
  period?: string
  description: React.ReactNode
  features?: React.ReactNode[]
  buttonText: string
  buttonVariant?: "default" | "outline" | "secondary" | "destructive" | "ghost"
  onButtonClick: () => void
  children?: React.ReactNode
  schoolCounterContent?: React.ReactNode
}

export function PricingCard({
  title,
  price,
  period,
  description,
  features,
  buttonText,
  buttonVariant = "default",
  onButtonClick,
  children,
  schoolCounterContent,
}: PricingCardProps) {
  return (
    <div className="tw-flex-1 tw-min-w-[110px] tw-max-w-[250px] tw-rounded-3xl tw-shadow-md tw-flex tw-flex-col tw-justify-between tw-border-gray-200 tw-border-2">
      {/* Fixed height header section */}
      <div className="tw-p-6 tw-pb-4 tw-h-[120px]">
        {" "}
        {/* Fixed height here */}
        <div className="tw-text-lg tw-font-black tw-text-gray-600 tw-mb-2.5">
          {title}
        </div>
        {price !== undefined && (
          <div className="tw-flex tw-items-baseline tw-text-lg sm:tw-text-xl md:tw-text-2xl lg:tw-text-3xl tw-font-black tw-text-gray-900 tw-mb-2 sm:tw-mb-3 md:tw-mb-4">
            {price}
            {period && (
              <span className="tw-text-base tw-font-normal tw-text-gray-700 tw-ml-0.5">
                {period}
              </span>
            )}
          </div>
        )}
        <div className="tw-flex-1 tw-overflow-hidden">
          <p className="tw-text-xs tw-text-gray-700 tw-leading-relaxed tw-line-clamp-2">
            {description}
          </p>
        </div>
      </div>

      <div className="tw-border-t tw-border-gray-200 tw-mb-4 tw-w-4/5 tw-ml-6"></div>

      <div className="tw-px-6 tw-pb-5 tw-flex-grow">
        {features &&
          features.map((feature, index) => (
            <div key={index} className="tw-flex tw-items-center tw-mb-4">
              <img
                className="tw-mr-2 tw-mt-1.5 tw-h-5"
                src={checkIcon}
                alt="Checklist"
              />
              <span className="tw-text-sm tw-text-gray-900 tw-font-medium">
                {feature}
              </span>
            </div>
          ))}
        {children}
      </div>

      {schoolCounterContent}

      <div className="tw-px-6 tw-pb-7">
        <Button
          className={`tw-w-full tw-py-4 tw-text-center tw-text-sm tw-font-semibold tw-border tw-rounded-[2px] ${
            buttonVariant === "outline"
              ? "tw-border-gray-200 tw-bg-white tw-text-gray-800 tw-transition-colors tw-duration-300 tw-hover:bg-gray-50"
              : ""
          }`}
          variant={buttonVariant}
          size="lg"
          onClick={onButtonClick}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  )
}
